import styled, { css } from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import ContentBlock from '@bitcoin-portal/bitcoincom-pkg-components/dist/ContentBlock';

export const Wrapper = styled.div`
  h2 {
    scroll-margin-top: 90px;
    font-size: 30px;
    font-family: 'Elza Condensed', sans-serif;
    font-weight: 500;
  }

  h3 {
    font-size: 24px;
    font-family: 'Elza Condensed', sans-serif;
    font-weight: 500;
  }

  p,
  li,
  tr {
    font-size: 16px;
    line-height: 24px;
    text-align: justify;
    font-family: 'Satoshi Variable Medium', sans-serif;
  }

  ${({ theme }) => css`
    width: 100%;
    position: relative;

    & > section {
      align-items: flex-start;
      padding-top: ${theme.spacing.unit * 4}px;
      padding-bottom: ${theme.spacing.unit * 4}px;
    }

    ${media.md`
    & > section {
      padding-top: ${theme.spacing.unit * 8}px;
    padding-bottom: ${theme.spacing.unit * 8}px;
    }
  `}
  `}
`;

export const Title = styled.header`
  text-align: center;
`;

export const StyledContentBlock = styled(ContentBlock)`
  padding-bottom: 100px;

  & > :last-child {
    align-self: stretch;
    display: flex;
    min-width: 250px;

    ${media.md`
      flex-basis: 30%;
    `}
  }

  & > :first-child {
    flex-basis: 100%;
    text-align: left;
    overflow: auto;

    ${media.md`
      flex-basis: 70%;
    `}
  }
`;
